import { EPostbackStatus } from '../../../types'
import { IPostbackStatusLang } from '../../../types/lang'

export const postbackStatusLang: IPostbackStatusLang = {
	postback_status: {
		[EPostbackStatus.Lead]: 'lead_ru',
		[EPostbackStatus.Sale]: 'sale_ru',
		[EPostbackStatus.Reject]: 'reject_ru',
	}
}